module.exports = __webpack_public_path__ + "static/media/dp1.d73f3fe1.png";